import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { UrlsProvider } from 'utils/urlUtils'
import { validateNumber, sipNumberFormat, numberValidationError } from 'utils/numberUtils'
import { CallPageTypes } from 'common/Enums'
import { useEventListener } from 'hooks'
import { changePhoneNumber, setupCall, validationPhoneError } from 'store/actions/call'
import PhoneInput from './components/PhoneInput'
import PhoneKeypad from './components/PhoneKeypad'
import DidsModal from './components/DidsModal'
import './Dialpad.scss'
import { getLastCall, setLastCall } from 'store/actions/global'

export function Dialpad() {
    const dispatch = useDispatch()
    const history = useHistory()

    const { loading, number } = useSelector((state) => state.global.lastCall)
    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        if (!loading && number) {
            setInputValue(number)
        }
    }, [number, loading])

    // Reset Last Call on dismount
    useEffect(() => {
        return () => {
            dispatch(setLastCall(''))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Actions
    const fillInputValue = (value) => {
        setInputValue(value || '')
    }

    const addInputValue = (value) => {
        setInputValue((prevState) => `${prevState}${value}`)
    }

    const resetInputValue = () => {
        setInputValue('')
    }

    const onBackspace = () => {
        setInputValue((prevState) => prevState.slice(0, -1))
    }

    const actionsDispatch = (val) => {
        const sipValue = sipNumberFormat(val)
        dispatch(changePhoneNumber({ number: sipValue }))
        dispatch(setupCall({ number: sipValue }))
        history.push(UrlsProvider.callUrlGenerator(CallPageTypes.Single))
    }

    const onCallHandler = () => {
        if (inputValue?.length) {
            validateNumber(inputValue)
                ? actionsDispatch(inputValue)
                : dispatch(validationPhoneError(numberValidationError(inputValue)))
        } else {
            dispatch(getLastCall())
        }
    }

    const onPressEnterHandler = (event) => {
        const keyName = event.key
        if (keyName === 'Enter') {
            onCallHandler()
        }
    }

    useEventListener('keyup', onPressEnterHandler)

    return (
        <div className="dialpad">
            <PhoneInput value={inputValue} onChange={fillInputValue} onReset={resetInputValue} onStickyInput={true} loading={loading} />
            <PhoneKeypad addInputValue={addInputValue} onBackspace={onBackspace} onCallHandler={onCallHandler} />
            <DidsModal />
        </div>
    )
}
